import React from 'react'

import {withOrderFormContext} from '../../../contexts'
import Photo from './Photo'

const Preview = ({layouts, collectionName, getQuantitySetFromFrameSize}) => {
    const quantityLimit = collectionName ? getQuantitySetFromFrameSize(collectionName) : 9999;
    return (
        <div className={collectionName?.name || ''}>
            <div className="container">
                {layouts.slice(0, quantityLimit).map((value, index) => (
                    <Photo photo={value} number={index} key={index}/>
                ))}
            </div>
        </div>
    )
}

export default withOrderFormContext(context => ({
    layouts: context.layouts,
    collectionName: context.frameSize,
    getQuantitySetFromFrameSize: context.getQuantitySetFromFrameSize
}))(Preview)